import { Divider, Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface IProps {
  number?: number;
  title: string;
  description: string;
  hasDivider?: string;
  disabled?: boolean;
}

export default function TitleDescription({
  number,
  title,
  description,
  hasDivider = "",
  disabled = false,
}: IProps) {
  const { t } = useTranslation();

  return (
    <Flex direction={"column"} align={"start"}>
      <Flex gap={12} align={"top"} justify={"center"}>
        {!!number ? (
          <Text
            fz="48px"
            mih="34px"
            color={disabled ? "basic.2" : "primary.1"}
            weight={700}
            mt="-16px"
            style={{ verticalAlign: "top" }}
            w="fit-content"
          >
            {number}
          </Text>
        ) : null}
        <Flex direction={"column"}>
          <Text
            fz="20px"
            mih="30px"
            color={disabled ? "basic.2" : "basic.5"}
            w="fit-content"
            weight={600}
            mt="-6px"
          >
            {t(title)}
          </Text>
          <Text
            fz="14px"
            h={{ base: "fit-content", 991: "20px" }}
            color={disabled ? "basic.2" : "basic.4"}
            w="fit-content"
          >
            {t(description)}
          </Text>
        </Flex>
      </Flex>

      {hasDivider ? <Divider w="100%" maw={hasDivider} mt="10px" /> : null}
    </Flex>
  );
}
